// 引入样式
require('./form.less');
// 加载基类
let DblClass = require('dbl-class');
// 地址
let region = require('./region');

// 加载弹框组件
let dbl_dialog = require('dbl-dialog');

let toChineseSpell = require('./py');

let form = DblClass.createClass({
  // 模板
  tpl: require('./form.ejs'),
  // 构造函数
  constructor: function (data) {
    this.extendCfg(data);
  },
  // 扩展配置
  extendCfg: function (data) {
    var data = data || {};
    data = $.extend(true, {}, this.config, data);
    this.config = data;
  },
  // 绑定事件
  events: {},
  defaultAjaxReq: {
    url: null,
    type: 'post',
    dataType: 'jsonp',
    async: false,
    jsonp: 'callback',
    data: null
  },
  // 异步请求方法
  ajaxRequest: function (ajaxReq) {
    ajaxReq = $.extend(true, {}, this.defaultAjaxReq, ajaxReq);
    let ajaxOptions = $.ajax(ajaxReq);
    return $.when(ajaxOptions);
  },
  // 自动填充
  autoFillCustomerInfo: function () {
    let self = this;
    let select = self.dataBind.autoFillCustomerInfoCheckBox.select;
    if (!select.prop('checked')) {
      // 清空
      let defaultData = { telArea: '86' };
      self.clear();
      self.fill(defaultData);
      return;
    }
    let ajaxReq = {
      url: self.config.ajaxAutoUrl,
      type: 'get',
      data: { regType: self.regType }
    };
    // jsonp 获取数据
    self.ajaxRequest(ajaxReq).then(function (result) {
      let _d = result.data;
      if (_d.c_province) {
        if (_d.c_province == '新疆维吾尔自治区') {
          _d.c_province = '新疆';
        } else if (_d.c_province == '内蒙古自治区') {
          _d.c_province = '内蒙古';
        } else if (_d.c_province == '宁夏回族自治区') {
          _d.c_province = '宁夏';
        } else if (_d.c_province == '广西壮族自治区') {
          _d.c_province = '广西';
        } else if (_d.c_province == '西藏自治区') {
          _d.c_province = '西藏';
        } else if (_d.c_province == '香港特别行政区') {
          _d.c_province = '香港';
        } else if (_d.c_province == '澳门特别行政区') {
          _d.c_province = '澳门';
        } else if (_d.c_province.indexOf('省', _d.c_province.length - '省'.length) !== -1) {
          _d.c_province = _d.c_province.substring(0, _d.c_province.length - 1);
        } else if (_d.c_province.indexOf('市', _d.c_province.length - '市'.length) !== -1) {
          _d.c_province = _d.c_province.substring(0, _d.c_province.length - 1);
        }
      }
      self.fill(_d);
      // 模拟触发校验一次
      $('input[class*=\'form-control\']').blur();
      $('select[class*=\'form-control\']').blur();
      $('input[name*=\'telMain\']').blur();
      //

    }).fail(function () { alert('自动添加信息模板错误，请重试'); });
  },
  popup: function (options) {
    if (!options || !options.callback) {
      return;
    }

    ////历史数据不存在auditStatus 默认为2 未提交实名认证
    if (options.data && options.data.realNameStatus === undefined) options.data.realNameStatus = 'NONAUDIT';

    let self = this;
    let innerHTML = self.tpl({ config: self.config });
    let html = '<div id="' + self.config.selectId + '">' + innerHTML + '</div>';
    var dialogOptions = {
      content: html,
      title: '域名持有者信息',
      width: 900,
      okValue: '确定',
      ok: ~([1, 3].indexOf(options.data && options.data.auditStatus ? options.data.auditStatus : 'undefined')) ? undefined : function () {
        self.valid().success(function () {
          dialogOptions.callback(self);
          dialog.close();
          dialog.remove();
        }).fail(function () { });
        return false;
      },
      cancelValue: '取消',
      cancel: function () { },
      callback: options.callback
    };
    if (options.title) {
      dialogOptions.title = options.title;
    }
    if (options.width) {
      dialogOptions.width = options.width;
    }
    if (options.okValue) {
      dialogOptions.okValue = options.okValue;
    }
    if (options.cancelValue) {
      dialogOptions.cancelValue = options.cancelValue;
    }

    var dialog = dbl_dialog(dialogOptions);
    dialog.showModal();
    self.initDataBind();
    self.bindEvents();
    self.clear();
    if (options.data) {
      self.fill(options.data);
    } else {
      let defaultData = { telArea: '86' };
      self.fill(defaultData);
    }
  },
  render: function () {
    let self = this;
    let innerHTML = self.tpl({ config: self.config });
    $('#' + self.config.selectId).html(innerHTML);
    self.initDataBind();
    self.bindEvents();
    let defaultData = { telArea: '86' };
    self.fill(defaultData);
  },
  // 表单验证是否通过
  valid: function () {
    let self = this;
    let successCallback = function () { };
    let failCallback = function () { };
    var retObj = {
      success: function (callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        successCallback = callback;
        return retObj;
      },
      fail: function (callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        failCallback = callback;
        return retObj;
      }
    };
    setTimeout(function () {
      let valid = self.dataBind.contact_form.select.valid();
      if (valid) {
        self.checkContact().success(successCallback).fail(failCallback);
      } else {
        failCallback();
      }
    }, 1);
    return retObj;
  },
  //变更企业类型,在做为域名联系人信息嵌入表单时使用
  switchRegType: function (regType) {
    let self = this;
    self.dataBind.regType.set(regType);
  },
  // 初始化配置

  config: {
    selectId: 'contact_form',
    displayMode: 2, //1:域名信息模板新建/详情编辑弹窗页面 2:域名联系人信息嵌入表单
    regType: 1, //默认所有者类型
    validation: $.extend({}, require('./rules')),
    ajaxAutoUrl: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/fillContactWithCustomerInfo.json`,
    // ajaxValidUrl: "//domain.console.aliyun.com/contacttemplate/contactTmplApi/checkContactInfoData.json",
    ajaxValidUrl: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/checkContactInfoData.json?dtoken=` + (window.domainTokenID || ''),
    displayNameFieldAlways: 0,
    displayEnglishFields: 1
  },
  dataBindFn: {
    contact_form: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId + '_contactForm');
      },
      bindEvent: function () {
        let self = this;
        if (self.select.length == 0) {
          return;
        }
        let validator = self.select.validate(self.form.config.validation);
        validator.errorsFor = function (element) {
          let name = element.name;
          let m = this.settings.tips[name];
          if (m && m.groupName)
            name = m.groupName;

          let tipsID = name + '_tips';
          return $('#' + self.form.config.selectId + '_' + tipsID);

        };
      }
    },
    regType: {
      init: function (form) {
        this.form = form;
        if (form.config.regType) {
          this.val = form.config.regType;
        }
      },
      bindEvent: function () { },
      regTypeChangeHandler: function () {
        let self = this;
        if (self.get() == '1') {
          $('#' + this.form.config.selectId).find('input[name=\'regType\']').val('1');
          if (this.form.config.displayMode == 1) {
            var regTypeDesc_selector = $('#' + this.form.config.selectId + '_regTypeDesc');
            regTypeDesc_selector.html('个人');
          }
          var c_company_selector = $('#' + this.form.config.selectId).find('input[name=\'c_company\']');
          c_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者名称（中文）：');
          var e_company_selector;
          if (self.form.config.displayEnglishFields == 1) {
            e_company_selector = $('#' + this.form.config.selectId).find('input[name=\'e_company\']');
            e_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者名称（英文）：');
          }
          if (self.form.config.displayNameFieldAlways == 0) {
            var c_name_selector = $('#' + this.form.config.selectId).find('input[name=\'c_name\']');
            if (c_name_selector.length > 0) {
              self.c_name = c_name_selector.val();
              c_name_selector.closest('tr').remove();
            }
            if (self.form.config.displayEnglishFields == 1) {
              var e_name_selector = $('#' + this.form.config.selectId).find('input[name=\'e_name\']');
              if (e_name_selector.length > 0) {
                self.e_name = e_name_selector.val();
                e_name_selector.closest('tr').remove();
              }
            }
          }
        } else if (self.get() == '2') {
          $('#' + this.form.config.selectId).find('input[name=\'regType\']').val('2');
          if (this.form.config.displayMode == 1) {
            var regTypeDesc_selector = $('#' + this.form.config.selectId + '_regTypeDesc');
            regTypeDesc_selector.html('企业');
          }
          var c_company_selector = $('#' + this.form.config.selectId).find('input[name=\'c_company\']');
          c_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者单位名称（中文）：');
          var e_company_selector;
          if (self.form.config.displayEnglishFields == 1) {
            e_company_selector = $('#' + this.form.config.selectId).find('input[name=\'e_company\']');
            e_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者单位名称（英文）：');
          }
          if (self.form.config.displayNameFieldAlways == 0) {
            var c_name_selector = $('#' + this.form.config.selectId).find('input[name=\'c_name\']');
            if (c_name_selector.length == 0) {
              c_company_selector.closest('tr').after(
                '          <tr >\r' +
                '            <td  align="right"><span class="text-danger">*</span>域名管理联系人（中文）：</td>\r' +
                '            <td >\r' +
                '                <input type="text" class="form-control tao-w300 " maxlength="128" name="c_name" value=""  />\r' +
                '                <span class="tips" id="' + self.form.config.selectId + '_c_name_tips"></span>\r' +
                '            </td>\r' +
                '        </tr>\r'
              );
              if (self.c_name) {
                $('#' + this.form.config.selectId).find('input[name=\'c_name\']').val(self.c_name);
              }
              if (self.form.config.displayEnglishFields == 1) {
                var e_name_selector = $('#' + this.form.config.selectId).find('input[name=\'e_name\']');
                if (e_name_selector.length == 0) {
                  e_company_selector.closest('tr').after(
                    '          <tr >\r' +
                    '            <td  align="right"><span class="text-danger">*</span>域名管理联系人（英文）：</td>\r' +
                    '            <td >\r' +
                    '                <input type="text" class="form-control tao-w300 " maxlength="128" name="e_name" value=""  />\r' +
                    '                <span class="tips" id="' + self.form.config.selectId + '_e_name_tips"></span>\r' +
                    '            </td>\r' +
                    '        </tr>\r'
                  );
                  if (self.e_name) {
                    $('#' + this.form.config.selectId).find('input[name=\'e_name\']').val(self.e_name);
                  }
                }
              }
            }
          }
        }
      },
      set: function (val) {
        if (!val || val != '1' && val != '2') {
          return;
        }
        this.val = val;
        this.regTypeChangeHandler();
      },
      get: function () {
        return this.val;
      }
    },
    autoFillCustomerInfoCheckBox: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId + '_autoFillCustomerInfo');
      },
      bindEvent: function () {
        let self = this;
        if (self.select.length > 0) {
          self.select.on('click', function (event) {
            self.form.autoFillCustomerInfo();
          });
        }
      }
    },
    c_country: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('select[name=\'c_country\']');
      },
      set: function (val) {
        if (!val) {
          return;
        }
        try {
          if (isNaN(val)) {
            var country = region.getRegionByCode(val);
          } else {
            var country = region.getRegionByID(val);
          }

          this.select.val(country.code);
          if ($.inArray(country.code, ['CN', 'HK', 'OM', 'TW']) != -1) {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('1');
          } else {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('2');
          }
          this.form.dataBind.c_province.renderProvinceSelect();
        } catch (e) {
          var country = region.getRegionByCode('CN');
          this.select.val(country.code);
          if ($.inArray(country.code, ['CN', 'HK', 'OM', 'TW']) != -1) {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('1');
          } else {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('2');
          }
          this.form.dataBind.c_province.renderProvinceSelect();
        }
      },
      get: function () {
        return this.select.val();
      },
      renderRegionSelect: function () {
        let regions = region.getAllRegions();
        for (let i in regions) {
          this.select.append('<option value="' + regions[i].code + '">' + regions[i].title + '</option>');
        }
        this.form.dataBind.c_province.renderProvinceSelect();
        //this.select.val() 
        this.setTelArea(this.select.val());
      },
      // 国家代码强制86 
      setTelArea: function (code) {
        let telArea = $('#' + this.form.config.selectId).find('input[name=\'telArea\']');
        let regions = region.getAllRegions();
        if (telArea.length == 1) {
          for (let i in regions) {
            if (code == regions[i].code) {
              telArea.val(regions[i].prefix);
            }
          }
        }
      },
      regionChangeHandler: function () {
        this.form.dataBind.c_province.renderProvinceSelect();
        let code = this.select.val();
        this.setTelArea(code);

        if ($.inArray(code, ['CN', 'HK', 'OM', 'TW']) != -1) {
          $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('1');
        } else {
          $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('2');
        }
      },
      bindEvent: function () {
        let self = this;
        this.select.change(function () {
          self.regionChangeHandler();
        });
      }
    },
    c_province: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('select[name=\'c_province\']');

      },
      set: function (val) {
        try {
          this.select.val(val);
          this.form.dataBind.c_city.renderCitySelect();
        } catch (e) { }
      },
      get: function () {
        return this.select.val();
      },
      provinceChangeHandler: function () {
        this.form.dataBind.c_city.renderCitySelect();
        let val = this.get();
        if (val) {
          let selectedProvince = region.getProvinceByTitle(val);
          if (selectedProvince != null) {
            var provincePinYin = toChineseSpell(selectedProvince.title);
            $('#' + this.form.config.selectId).find('input[name=\'e_province\']').val(provincePinYin);
          }
        }
      },
      renderProvinceSelect: function () {
        let code = this.form.dataBind.c_country.get();
        let rg = region.getRegionByCode(code);
        this.select.empty();
        this.select.append('<option value="">-省份-</option>');
        if (rg == null) {
          this.form.dataBind.c_city.renderCitySelect();
          return;
        }
        let provinces = region.getProvinces(rg.regionID);
        let citySelect = this.form.dataBind.c_city.select;
        if (provinces.length < 1) {
          this.select.hide();
          citySelect.hide();
          this.set(rg.title);
          this.form.dataBind.c_city.set(rg.title);
          let regionPinyin = toChineseSpell(rg.title);
          $('#' + this.form.config.selectId).find('input[name=\'e_province\']').val(regionPinyin);
          $('#' + this.form.config.selectId).find('input[name=\'e_city\']').val(regionPinyin);
        } else {
          this.select.show();
          citySelect.show();
          for (let i in provinces) {
            this.select.append('<option value="' + provinces[i].title + '">' + provinces[i].title + '</option>');
          }
        }
        this.form.dataBind.c_city.renderCitySelect();
      },
      bindEvent: function () {
        let self = this;
        this.select.change(function () {
          self.provinceChangeHandler();
        });
      }
    },
    c_city: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('select[name=\'c_city\']');
      },
      set: function (val) {
        try {
          this.select.val(val);
        } catch (e) { }
      },
      get: function () {
        return this.select.val();
      },
      cityChangeHandler: function () {
        let cityVal = this.get();
        let provinceVal = this.form.dataBind.c_province.get();
        if (cityVal && provinceVal) {
          let selectedCity = region.getCityByTitle(cityVal, provinceVal);
          if (selectedCity != null) {
            let regionPinyin = toChineseSpell(selectedCity.title);
            $('#' + this.form.config.selectId).find('input[name=\'e_city\']').val(regionPinyin);
          }
        }
      },
      renderCitySelect: function () {
        let provinceTitle = this.form.dataBind.c_province.get();

        this.select.empty();
        this.select.append('<option value="">-城市-</option>');
        if (provinceTitle == '') {
          return;
        }
        let citys = region.getCityByProvinceTitle(provinceTitle);
        if (!citys) {
          return;
        }
        for (let i in citys) {
          this.select.append('<option value="' + citys[i].title + '">' + citys[i].title + '</option>');
        }
      },
      bindEvent: function () {
        let self = this;
        this.select.change(function () {
          self.cityChangeHandler();
        });
      }
    },
    c_company: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'c_company\']');
      },
      set: function (val) {
        this.select.val(val);
      },
      get: function () {
        return this.select.val();
      },
      bindEvent: function () {
        let self = this;
        this.select.change(function () {
          self.changeHandler();
        });
      },
      changeHandler: function () {
        let self = this;
        let e_company_select = $('#' + this.form.config.selectId).find('input[name=\'e_company\']');
        if (e_company_select.length > 0) {
          let val = toChineseSpell(self.get());
          e_company_select.val(val);
        }
      }
    },
    c_name: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'c_name\']');
      },
      set: function (val) {
        this.select.val(val);
      },
      get: function () {
        return this.select.val();
      },
      bindEvent: function () {
        let self = this;
        this.select.change(function () {
          self.changeHandler();
        });
      },
      changeHandler: function () {
        let self = this;
        let e_name_select = $('#' + this.form.config.selectId).find('input[name=\'e_name\']');
        if (e_name_select.length > 0) {
          let val = toChineseSpell(self.get());
          e_name_select.val(val);
        }
      }
    },
    c_venu: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'c_venu\']');
      },
      set: function (val) {
        this.select.val(val);
      },
      get: function () {
        return this.select.val();
      },
      bindEvent: function () {
        let self = this;
        this.select.change(function () {
          self.changeHandler();
        });
      },
      changeHandler: function () {
        let self = this;
        let e_venu_select = $('#' + this.form.config.selectId).find('input[name=\'e_venu\']');
        if (e_venu_select.length > 0) {
          let val = toChineseSpell(self.get());
          e_venu_select.val(val);
        }
      }
    },
    defaultTemplate: {
      init: function (form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'defaultTemplate\']');
      },
      bindEvent: function () {
        let self = this;
        if (self.select.length > 0) {
          self.select.click(function () {
            if (self.select.is(':checked')) {
              self.select.val('1');
            } else {
              self.select.val('0');
            }
          });
        }
      },
      set: function (val) {
        if (this.select.length == 0) {
          return;
        }
        if (val != '0' && val != '1') {
          return;
        }
        this.select.val(val);
        if (val == '1') {
          this.select.prop('checked', true);
        }
      },
      get: function () {
        if (this.select.length == 0) {
          return;
        }
        return this.select.val();
      }
    }

  },

  fill: function (data) {
    let self = this;
    data = data || {};
    //需要按顺序填充的字段
    let exludeFields = ['c_country', 'c_province', 'e_province', 'c_city', 'e_city'];
    self.dataBind.contact_form.select.find('input,select,textarea').each(function () {
      let element = $(this);
      let name = element.attr('name');
      if (name == 'regionType') {
        return;
      }
      if ($.inArray(name, exludeFields) != -1) {
        return;
      }
      if (name && data[name] !== undefined) {
        if (self.dataBind[name] && self.dataBind[name].set) {
          self.dataBind[name].set(data[name]);
        } else {
          // 判断国家地区为CN 
          if (data.c_country == 'CN' && name == 'telArea') {
            element.attr('value', 86);
          } else if (name == 'telArea' && !data[name]) {
            element.attr('value', 86);
          } else {
            element.attr('value', data[name]);
          }

        }
      }
    });
    if (data.c_country) {
      self.dataBind.c_country.set(data.c_country);
    }
    if (data.c_province) {
      self.dataBind.c_province.set(data.c_province);
      if (data['c_province'] && !data['e_province']) {
        self.dataBind.c_province.select.change();
      }
    }
    if (data.c_city) {
      self.dataBind.c_city.set(data.c_city);
      if (data['c_city'] && !data['e_city']) {
        self.dataBind.c_city.select.change();
      }
    }
    if (data.e_province) {
      $('#' + self.config.selectId).find('input[name=e_province]').val(data.e_province);
    }
    if (data.e_city) {
      $('#' + self.config.selectId).find('input[name=e_city]').val(data.e_city);
    }
    if (data['c_company'] && !data['e_company']) {
      self.dataBind.c_company.select.change();
    }
    if (data['c_name'] && !data['e_name']) {
      self.dataBind.c_name.select.change();
    }
    if (data['c_venu'] && !data['e_venu']) {
      self.dataBind.c_venu.select.change();
    }
  },
  clear: function () {
    let self = this;
    this.dataBind.contact_form.select.find('input,select,textarea').each(function () {
      let element = $(this);
      if (element.is(':hidden')) {
        return;
      }
      let name = element.attr('name');
      if (self.dataBind[name] && self.dataBind[name].set) {
        self.dataBind[name].set('');
      } else {
        element.attr('value', '');
      }
    });
    let defaultData = { telArea: '86' };
    self.fill(defaultData);
  },
  getFormData: function () {

    let o = {};
    let a = this.dataBind.contact_form.select.serializeArray();
    $.each(a, function () {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    if (this.config.displayMode == 1) {
      o.defaultTemplate = this.dataBind.defaultTemplate.get();
    } else if (this.config.displayMode == 2) {
      //if (o.c_name === undefined  && o.regType && (o.regType=="1")  && o.c_company !==undefined) {
      //  o.e_company = o.c_company;
      //}
      //if (o.e_name === undefined  && o.regType && (o.regType=="1")  && o.e_company !==undefined) {
      //  o.e_name = o.e_company;
      //}
    }
    if ($.inArray(o.c_country, ['CN', 'HK', 'OM', 'TW']) == -1) {
      let rg = region.getRegionByCode(o.c_country);
      o.c_province = rg.title;
      o.c_city = rg.title;
    }
    if (o.regionType) {
      delete o.regionType;
    }
    return o;
  },
  checkContact: function () {
    let self = this;
    let successCallback = function () { };
    let failCallback = function () { };
    var retObj = {
      success: function (callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        successCallback = callback;
        return retObj;
      },
      fail: function (callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        failCallback = callback;
        return retObj;
      }
    };
    let template = self.getFormData();
    if (template._csrf_token) {
      delete template._csrf_token;
    }
    let jqxhr = $.ajax({
      url: self.config.ajaxValidUrl,
      //type: 'get',
      dataType: 'jsonp',
      async: false,
      cache: false,
      jsonp: 'callback',
      data: template
    });
    jqxhr.done(function (data) {
      let html = '';
      if (!data.success) {
        for (let x in data.module) {
          // if (template[name] !== undefined) {
          html += '<p>' + data.module[x] + '</p>';
          // }
        }
        if (html) {
          let dialogOptions = {
            content: html,
            title: '错误信息',
            width: 400,
            okValue: '确定',
            ok: function () {
              return true;
            },
            cancelValue: '取消',
            cancel: function () { }
          };
          let dialog = dbl_dialog(dialogOptions);
          dialog.show();
          return;
        }
      }
      successCallback();
    }).fail(failCallback);
    return retObj;
  },
  initDataBind: function () {
    let self = this;
    self.dataBind = {};
    for (let prop in self.dataBindFn) {
      if (!self.dataBindFn.hasOwnProperty(prop) || !self.dataBindFn[prop].init) {
        continue;
      }
      self.dataBindFn[prop].init.prototype = self.dataBindFn[prop];
      self.dataBind[prop] = new self.dataBindFn[prop].init(this);
    }
  },
  bindEvents: function () {
    let self = this;
    self.dataBind.contact_form.bindEvent();
    self.dataBind.regType.bindEvent();
    self.dataBind.c_country.bindEvent();
    self.dataBind.c_province.bindEvent();
    self.dataBind.c_city.bindEvent();
    self.dataBind.defaultTemplate.bindEvent();
    self.dataBind.autoFillCustomerInfoCheckBox.bindEvent();
    self.dataBind.c_company.bindEvent();
    self.dataBind.c_name.bindEvent();
    self.dataBind.c_venu.bindEvent();
    self.dataBind.c_country.renderRegionSelect();
  },
  addHiddenInputField: function (html) {
    $('#' + this.config.selectId + '_contactForm').append(html);
  },
  replaceField: function (fieldName, html) {
    if (!fieldName) {
      return;
    }
    let select = $('#' + this.config.selectId + '_' + fieldName + '_td');
    if (select.length > 0) {
      select.html(html);
    }
  },
  resetFieldDefault: function (fieldName) {
    let self = this;
    if (!fieldName) {
      return;
    }
    let select = $('#' + this.config.selectId + '_' + fieldName + '_td');
    if (select.length == 0) {
      return;
    }
    let html;
    if (fieldName == 'c_company') {
      html = '' +
        '                <input type="text" class="form-control tao-w300 " maxlength="128" name="c_company" value=""  />\n' +
        '                <span class="tips" id=' + this.config.selectId + '_c_company_tips"></span>';
      select.html(html);
      self.dataBind.c_company.init(self);
      self.dataBind.c_company.bindEvent();
    } else if (fieldName == 'e_company') {
      html = '' +
        '                <input type="text" class="form-control tao-w300 " maxlength="128" name="e_company" value=""  />\n' +
        '                <span class="tips" id="' + this.config.selectId + '_e_company_tips"></span>';
      select.html(html);
    }
  },
  replaceFieldLabel: function (fieldName, val) {
    if (!fieldName) {
      return;
    }
    let select = $('#' + this.config.selectId + '_' + fieldName + '_label_td');
    if (select.length == 0) {
      return;
    }
    let self = this;
    if (fieldName == 'c_company' || fieldName == 'e_company') {
      select.html('<span class="text-danger">*</span>' + val);
    } else if (fieldName == 'c_name' || fieldName == 'e_name') {
      select.html('<span class="text-danger">*</span>' + val);
    }
  },
  resetFieldLabelDefault: function (fieldName) {
    if (!fieldName) {
      return;
    }
    let select = $('#' + this.config.selectId + '_' + fieldName + '_label_td');
    if (select.length == 0) {
      return;
    }
    if (fieldName == 'c_company') {
      var regType = $('#' + this.config.selectId).find('input[name=\'regType\']').val();
      if (regType == '1') {
        select.html('<span class="text-danger">*</span>' + '域名持有者名称（中文）：');
      } else {
        select.html('<span class="text-danger">*</span>' + '域名持有者单位名称（中文）：');
      }
    } else if (fieldName == 'e_company') {
      var regType = $('#' + this.config.selectId).find('input[name=\'regType\']').val();
      if (regType == '1') {
        select.html('<span class="text-danger">*</span>' + '域名持有者名称（英文）：');
      } else {
        select.html('<span class="text-danger">*</span>' + '域名持有者单位名称（英文）：');
      }
    } else if (fieldName == 'c_name') {
      select.html('<span class="text-danger">*</span>' + '域名管理联系人（中文）：');
    } else if (fieldName == 'e_name') {
      select.html('<span class="text-danger">*</span>' + '域名管理联系人（英文）：');
    }
  },
  addRow: function (data) {
    if (!data || !data.labelName && !data.labelHtml || !data.fieldHtml) {
      return;
    }
    let select;
    if (data.afterRow) {
      select = $('#' + this.config.selectId).find('input[name=\'' + data.afterRow + '\']');
    } else if (data.beforeRow) {
      select = $('#' + this.config.selectId).find('input[name=\'' + data.beforeRow + '\']');
    } else {
      select = $('#' + this.config.selectId).find('form > table > tbody');
    }
    if (select.length > 0) {
      let innerHTMLArray = new Array();
      innerHTMLArray.push('        <tr >\r');
      innerHTMLArray.push('       <td  align="right">');
      if (data.labelHtml) {
        innerHTMLArray.push(data.labelHtml);
      } else if (data.labelName) {
        if (data.labelRequire) {
          innerHTMLArray.push('<span class="text-danger">*</span>');
        }
        innerHTMLArray.push(data.labelName);
      }
      innerHTMLArray.push('</td>\\r');
      innerHTMLArray.push('        <td >\r');
      innerHTMLArray.push(data.fieldHtml);
      innerHTMLArray.push('\r');
      innerHTMLArray.push('            </td>\r');
      innerHTMLArray.push('            </tr>\r');
      if (data.beforeRow) {
        select.closest('tr').before(innerHTMLArray.join());
      } else {
        select.closest('tr').after(innerHTMLArray.join());
      }

    }
  },
  removeRow: function (data) {
    if (!data || !data.fieldName && !data.selector) {
      return;
    }
    let select;
    if (data.selector) {
      select = $(selector);
    } else if (data.fieldName) {
      select = $('#' + this.config.selectId).find('input[name=\'' + data.fieldName + '\']').closest('tr');
    }
    if (select.length > 0) {
      select.remove();
    }
  },

  disable: function (fieldName) {
    $('[name="' + fieldName + '"]').attr('readonly', true);
  },

  enable: function (fieldName) {
    $('[name="' + fieldName + '"]').removeAttr('readonly');
  },

  after: function (fieldName, element) {
    $('[name="' + fieldName + '"]').after(element);
  }

});

module.exports = form;




// WEBPACK FOOTER //
// ./src/scripts/components/contactForm/form.js